export function anchorheader_viewportLeave() {
    $w("#hiddenStrip1").show();
    $w("#hiddenStrip3").show();
    $w("#stripH1").hide();
    $w("#stripH2").hide();
    $w("#stripH3").hide();
    $w("#lineH1").hide();
    }

export function anchorheader_viewportEnter() {
    $w("#hiddenStrip1").hide();
    $w("#hiddenStrip3").hide();
    $w("#stripH1").show();
    $w("#stripH2").show();
    $w("#stripH3").show();
    $w("#lineH1").show();
}

